<template>
  <div>
    <StepTitle :value="mainStore.currentStepContent.title" class="mb-8" />

    <span class="mb-2 block px-0.5 text-body-color">{{ label }}</span>
    <label
      v-for="option in options"
      :id="`project-option-${option.name}`"
      :key="option.id"
      class="relative w-full cursor-pointer rounded-lg p-4 text-body-color transition-all"
      :class="[selectedOptions.includes(option.id) ? option.classes.bg + ' bg-opacity-10' : 'bg-slate-100']"
    >
      <div class="flex items-center space-x-3">
        <span :class="[option.classes.text]" class="font-medium">{{ option.title }}</span>
        <span class="rounded-full px-2 py-1 text-sm text-white" :class="[option.classes.bg]">{{ option.label }}</span>
        <span class="grow"></span>
        <span v-html="cleanAmount(option.price)"></span>
        <span class="flex h-5 w-5 items-center justify-center !rounded border bg-white">
          <span class="scale-75" :class="[{ 'opacity-0': !selectedOptions.includes(option.id) }]">
            <fa-icon type="fas" icon="check" :class="[option.classes.text]" />
          </span>
        </span>
      </div>
      <hr />
      <p>{{ option.description }}</p>

      <input
        :id="option.name"
        v-model="selectedOptions"
        type="checkbox"
        :value="option.id"
        name="project[project_option_ids][]"
        class="absolute right-0 top-0 opacity-0"
      />
    </label>

    <portal v-if="active" to="fast-footer">
      <div class="flex w-full items-center justify-end md:justify-between">
        <div class="hidden md:block">Options facultatives</div>
        <button class="btn btn-primary" type="button" tabindex="-1" @click="proceed" v-html="finishButtonLabel"></button>
      </div>
    </portal>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { ALERTS, STEPS, useMainStore } from '@/apps/fast/store'

export default {
  data() {
    return {
      selectedOptions: []
    }
  },
  computed: {
    ...mapStores(useMainStore),
    active() {
      return this.mainStore.step === STEPS.options
    },
    label() {
      return this.mainStore.stepContent(STEPS.options).label
    },
    finishButtonLabel() {
      if (this.selectedOptions.length < 1) {
        return this.mainStore.lightMode ? 'Annuler' : 'Publier gratuitement'
      } else {
        return `Passer au paiement <small>(${this.cleanAmount(this.totalAmount)})</small>`
      }
    },
    options() {
      const projectOptions = this.mainStore.content.projectOptions
      const availableOptions = this.mainStore.project?.availableOptions

      const options = availableOptions
        ? projectOptions.filter(option => availableOptions.includes(option.name))
        : projectOptions

      return options.map(option => {
        return {
          ...option,
          classes: this.optionClasses(option.name)
        }
      })
    },
    totalAmount() {
      return this.selectedOptions
        .reduce((sum, optionId) => sum + Number.parseFloat(this.getOptionById(optionId).price), 0.0)
        .toFixed(2)
    }
  },
  methods: {
    enter() {
      this.$root.sendMatomoPageView('options')
    },
    cleanAmount(amount, currencySymbol = '€') {
      return (
        Number.parseFloat(amount).toFixed(2).replace('.', ',') +
        '&#8239;' +
        currencySymbol +
        '&nbsp;<span class="text-sm font-light">HT</span>'
      )
    },
    getOptionById(optionId) {
      return this.options.find(option => option.id === optionId)
    },
    optionClasses(optionName) {
      if (optionName === 'premium') {
        return {
          bgChecked: 'checked:bg-project-option-premium',
          bg: 'bg-project-option-premium',
          text: 'text-project-option-premium'
        }
      } else if (optionName === 'urgent') {
        return {
          bgChecked: 'checked:bg-project-option-urgent',
          bg: 'bg-project-option-urgent',
          text: 'text-project-option-urgent'
        }
      } else if (optionName === 'hidden') {
        return {
          bgChecked: 'checked:bg-project-option-hidden',
          bg: 'bg-project-option-hidden',
          text: 'text-project-option-hidden'
        }
      } else {
        return {
          bgChecked: '',
          bg: '',
          text: ''
        }
      }
    },
    proceed() {
      if (this.selectedOptions.length > 0) {
        this.$root.sendMatomoPageView('buy-options')
        this.mainStore.project.options = this.selectedOptions
        this.submitProjectOptions()
      } else if (this.mainStore.lightMode) {
        this.$root.close()
      } else {
        this.$root.sendMatomoPageView('skip-options')
        this.mainStore.alert = ALERTS.success
      }
    },
    async submitProjectOptions() {
      try {
        this.mainStore.submitting = true
        const { body } = await this.$http.post(this.mainStore.project.addOptionsUrl, {
          option_ids: this.mainStore.project.options
        })
        this.$root.sendMatomoPageView('options-finished')
        if ('order_url' in body) {
          document.location.href = body.order_url
        } else {
          this.mainStore.submitting = false
        }
      } catch (error) {
        this.$root.sendMatomoPageView('options-errored')
        this.$emit('ajaxerror', error)
        this.mainStore.submitting = false
      }
    }
  }
}
</script>
